import React, { useEffect } from 'react';
import './Reservation.scss';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { filter, map, size, find } from 'lodash';
import { Button } from '../utils/forms/Button';
import { SHARE_PLACE_ROUTE } from '../router/routes';
import { getUserPlaces } from '../../actions/parkingSpotActions';
import ReservationsList from './ReservationsList';
import NoReservations from './NoReservations';

export default function () {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth.id);
  const reservationData = useSelector((state) =>
    filter(state.reservations, (r) => r.userId === userId)
  );
  const userPlaces = useSelector((state) =>
    filter(state.spots, (spot) => spot.userId)
  );
  const history = useHistory();

  useEffect(() => {
    dispatch(getUserPlaces());
  }, []);

  function sharePlace(place) {
    history.push(SHARE_PLACE_ROUTE.replace(':spotId', place.placeId), place);
  }

  return (
    <div className="scrollable" style={{ maxHeight: 320 }}>
      <div className="mb2 right-align">
        {map(userPlaces, (place) => (
          <div key={place.placeId}>
            <Button
              type="button"
              color="share-place"
              onClick={() => sharePlace(place)}
            >
              <span className="share-place__header">
                Sdílet své stálé místo {place.place}
              </span>

              <i className="far fa-share-square ml1" />
            </Button>
          </div>
        ))}
      </div>

      {size(reservationData) < 1 ? (
        <NoReservations />
      ) : (
        <ReservationsList reservationData={reservationData} />
      )}
    </div>
  );
}
